<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="ADIANTAMENTO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/business-and-finance1.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/adiantamentos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="!entidadeForm.get('data_prestacao').value" data-toggle="modal" data-target="#dialogPrestacao"
            class="btn btn-sm btn-outline-secondary float-right mr-4" height="22" width="22">
            <img src="assets/img/global/total_plan_cost.png" alt="finalizar" title="Finalizar adiantamento" height="20"
              width="20">
            Prestação de contas
          </button>
          <button *ngIf="entidadeForm.get('id').value" (click)="imprimir()"
            class="btn btn-sm btn-outline-secondary float-right mr-1">
            <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir processo adiantamento" height="22"
              width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar Adiantamento</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-8">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="numero" class="mr-2 font-weight-bold" style="color: #009688 ">NÚMERO:</label>
              <input id="numero" formControlName="numero" type="text" class="form-control"
                style="font-weight: bold; color: #1e88e5">
            </div>
            <div class="form-group col-md-2">
              <label for="oficio">Ofício N˚</label>
              <input #oficio formControlName="oficio" type="text" class="form-control font-weight-bold" id="oficio">
            </div>
            <div class="form-group col-md-2">
              <label for="empenho">Empenho N˚</label>
              <p-autoComplete #numero_empenho id="numero_empenho" formControlName="empenho"
                [field]="empenhoAutoComplete.conversor" [suggestions]="empenhoAutoComplete.lista"
                (completeMethod)="empenhoAutoComplete.filtrar($event)" inputStyleClass="form-control" minLength="1"
                [forceSelection]="true" [autoHighlight]="true" (onSelect)="preencherFavorecido($event)">
                <ng-template let-empenho pTemplate="item">
                  {{empenho.numero}}/{{empenho.exercicio.ano}}
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="form-group col-md-3">
              <label for="valor_adiantado">Valor adiantamento</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_adiantado" type="text"
                class="form-control" id="valor_adiantado" placeholder="0,00"
                style="font-weight: bold; color: #1e88e5; background-color: #ffffff">
            </div>
            <div class="form-group col-md-3">
              <label for="selectMotivo">Motivo<span class="text-danger">*</span></label>
              <select name="selectMotivo" formControlName="especie" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaEspecies">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="data_adiantamento">Adiantamento<span class="text-danger">*</span></label>
              <p-calendar id="data_adiantamento" formControlName="data_adiantamento" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-3">
              <label for="data_vencimento">Vencimento</label>
              <p-calendar id="data_vencimento" formControlName="data_vencimento" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-3">
              <label for="data_liberacao">Liberação</label>
              <p-calendar id="data_liberacao" formControlName="data_liberacao" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-3">
              <label for="selectSituacao">Situação<span class="text-danger">*</span></label>
              <select name="selectSituacao" formControlName="situacao" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaSituacoes">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div *ngIf="entidadeForm.get('data_prestacao').value" class="form-group col-md-3">
              <label for="data_prestacao">Data Prestação</label>
              <p-calendar id="data_prestacao" formControlName="data_prestacao" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div *ngIf="entidadeForm.get('data_prestacao').value" class="form-group col-md-3">
              <label for="selectParecer">Parecer<span class="text-danger">*</span></label>
              <select name="selectParecer" formControlName="parecer" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaPareceres">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <hr class="mt-0" />
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="selectTipo">Beneficiário<span class="text-danger">*</span></label>
              <select name="selectTipo" formControlName="tipo_beneficiario" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaTipos">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-5">
              <label for="beneficiario">Nome</label>
              <input formControlName="beneficiario" type="text" class="form-control font-weight-bold" id="beneficiario">
            </div>
            <div class="form-group col-md-3">
              <label for="cargo_beneficiario">Cargo</label>
              <input formControlName="cargo_beneficiario" type="text" class="form-control font-weight-bold"
                id="cargo_beneficiario">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="banco">Banco</label>
              <input formControlName="banco" type="text" class="form-control" id="banco">
            </div>
            <div class="form-group col-md-3">
              <label for="agencia">Agência</label>
              <input formControlName="agencia" type="text" class="form-control" id="agencia">
            </div>
            <div class="form-group col-md-4">
              <label for="numero_conta">Conta N˚</label>
              <input formControlName="numero_conta" type="text" class="form-control" id="numero_conta">
            </div>
          </div>

          <hr />
          <div class="form-row">
            <div class="form-group col-md-6" *ngIf="entidadeForm.get('especie').value === 'D'">
              <label for="selectDestino">Destino</label>
              <input formControlName="destino" type="text" class="form-control" id="destino">
            </div>
            <div class="col-md-3" *ngIf="entidadeForm.get('especie').value === 'D'">
              <label for="data_partida">Data Partida</label>
              <p-calendar id="data_partida" formControlName="data_partida" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="col-md-3" *ngIf="entidadeForm.get('especie').value === 'D'">
              <label for="data_chegada">Data Retorno</label>
              <p-calendar id="data_chegada" formControlName="data_chegada" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="motido">Observações<span class="text-danger">*</span></label>
              <textarea formControlName="motivo" class="form-control" id="motido" rows="5"></textarea>
            </div>
          </div>
          
          <div class="modal fade" id="dialogPrestacao" tabindex="-1" role="dialog" aria-labelledby="prestacao"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header bg-primary text-white">
                  <h5 class="modal-title" id="title">Prestação de contas</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-4">
                      <label for="data_prestacao1">Data Prestação</label>
                      <p-calendar id="data_prestacao1" formControlName="data_prestacao" inputStyleClass="form-control"
                        dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                        [showButtonBar]="true" [style]="{ width: '100%' }">
                      </p-calendar>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="selectParecer1">Parecer<span class="text-danger">*</span></label>
                      <select name="selectParecer1" formControlName="parecer" class="custom-select">
                        <option [value]="item.id" *ngFor="let item of listaPareceres">
                          {{item.nome}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label for="motido"></label>
                      <textarea formControlName="descricao_parecer" class="form-control" id="motido1"
                        rows="5"></textarea>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button (click)="salvarPrestacao()" type="submit" class="btn btn-primary" id="btnSalvar"
                    data-dismiss="modal">Salvar</button>
                  <button (click)="cancelarPrestacao()" type="button" class="btn btn-link" id="btnCancelar"
                    data-dismiss="modal">Cancelar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-4">
          <div class="card">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Valor Efetivado <span class="float-right">{{vlEfetivado |
                  number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item">Valor Devolução <span class="float-right">{{vlAnulado |
                  number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item font-weight-bold">Saldo Adiantamento<span
                  class="float-right font-weight-bold">{{saldo | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
        </div>      
      </div>
      <div class="row">
        <div class="col-12">
          <hr class="mt-3 mb-2" />
          <lib-adiantamento-documento [(lista)]="listaDocumentos" [(entidade)]="entidade" [login]="login">
          </lib-adiantamento-documento>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" type="submit" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" title="Salvar" height="20" width="20">
          Salvar & novo
        </button>
      </div>
    </div>
  </form>
</div>